/* scanSettingsScanSection.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const scanSettingsScanSectionComponent = {
  template: require('./scanSettingsScanSection.html'),
  bindings: {
    preview: '=',
    reset: '&'
  },
  controllerAs: 'vm',
  controller: class scanSettingsScanSectionController {
    /* @ngInject */
    constructor(scanService, sessionDataService, $state) {
      this.scanService = scanService
      this.sessionDataService = sessionDataService
      this.$state = $state
    }
    switchToPrint() {
      this.scanService.filename = null
      this.sessionDataService.lastOp = 'main'
      this.$state.go('print')
    }
    togglePreview() {
      this.preview = !this.preview
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/scan/components/scanSettingsScanSection.component.js